export default __webpack_public_path__ + "static/media/square.2d2754ce.svg";